// The list's rows on a phone: a stacked list, one row per item — the name and its state
// on the first line, the column values under it, the note under that. Tapping a row
// opens its sheet (ItemSheet), where the state is one tap and everything else is typed.
// Grouped (079), each group opens with a heading: its name, its count, how many finished.
import he from '../../i18n/he';
import { Chip } from './StateControl';
import { secondaryLine } from './listView';
import { toneClass } from './ListGlance';

export default function ListPhoneRows({ list, groups, locked, onOpen }) {
  const byId = new Map(list.states.map((s) => [s.id, s]));
  return (
    <div className="list-phone-rows">
      {groups.map((g) => [
        g.label != null && (
          <div key={`h-${g.key}`} className={`list-phone-group${g.tone ? ` ${toneClass(g.tone)}` : ''}`}>
            <span>{g.tone && <span className="dot" />}{g.label}</span>
            <span className="list-group-meta">{he.lists.groupMeta(g.items.length, g.finished)}</span>
          </div>
        ),
        ...g.items.map((it) => {
        const state = byId.get(it.state_id) || list.states[0];
        const body = (
          <>
            <span className="list-phone-top">
              <span className="list-phone-name">{it.name}</span>
              <Chip state={state} readOnly />
            </span>
            {secondaryLine(it, list.columns) && <span className="list-phone-sec">{secondaryLine(it, list.columns)}</span>}
            {it.note && <span className="list-phone-note">{it.note}</span>}
          </>
        );
        return locked
          ? <div key={it.id} className="list-phone-row">{body}</div>
          : (
            <button key={it.id} type="button" className="list-phone-row" onClick={() => onOpen(it.id)} aria-label={`${it.name} · ${he.lists.choose}`}>
              {body}
            </button>
          );
      }),
      ])}
    </div>
  );
}
